import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import passwordValidator from 'password-validator';

export class ValidatorsHelper {
    public static checkPasswordStrength(): ValidatorFn | null {
        const minimumPasswordLength = 8;
        const maximumPasswordLength = 32;
        return (control: AbstractControl): ValidationErrors | null => {
            if (control.value == null) {
                return null;
            }
            const plainPassword = (control.value as string).trim();
            const validator = new passwordValidator();
            validator
                .is()
                .min(minimumPasswordLength)
                .is()
                .max(maximumPasswordLength)
                .has()
                .uppercase()
                .has()
                .lowercase()
                .has()
                .digits()
                .has()
                .symbols()
                .is()
                .not()
                .oneOf(['+']);

            const containsOnlyPlusAsSymbol = /^[a-zA-Z0-9+]*$/.test(plainPassword) && plainPassword.includes('+');
            const isPasswordStrong = validator.validate(plainPassword) as boolean;

            if (containsOnlyPlusAsSymbol) {
                return { strongPassword: false };
            }

            if (isPasswordStrong) {
                return null;
            } else {
                return { strongPassword: true };
            }
        };
    }

    public static validateEmptyString(): ValidatorFn | null {
        return (control: AbstractControl): ValidationErrors | null => {
            if (control.value == null) {
                return null;
            }

            const value = control.value as string;
            if (value.length === 0) {
                return null;
            }
            const trimmedValue = value.trim();

            if (trimmedValue.length === 0) {
                return { emptyStringValue: true };
            } else {
                return null;
            }
        };
    }

    public static validateValueMatch(sourceControlName: string, targetControlName: string): ValidatorFn | null {
        return (control: AbstractControl): ValidationErrors | null => {
            const sourceControl = control.get(sourceControlName);
            const targetControl = control.get(targetControlName);
            if (
                sourceControl != null &&
                targetControl != null &&
                sourceControl.value != null &&
                targetControl.value != null &&
                sourceControl.value !== targetControl.value
            ) {
                return { passwordMismatch: true };
            } else {
                return null;
            }
        };
    }
}
